import Breadcrumb from './breadcrumb.vue';
import BreadcrumbItem from './breadcrumb-item';

Breadcrumb.BreadcrumbItem = BreadcrumbItem;

export default Breadcrumb;
